<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('record')" class="col-sm-4 col-form-label">Record</label>
        <div class="col-sm-8">
          <record-select :id="safeId('record')" v-model="recordId" :dataset-id="datasetId"></record-select>
        </div>
      </div>

      <div class="form-group form-row" v-if="datasetId">
        <div class="col-sm-4"></div>
        <div class="col-sm-8">
          <button type="button" class="btn btn-block btn-primary" @click="nextRecord(recordId, datasetId)">Next</button>
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('rank')" class="col-sm-4 col-form-label">Rank</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('rank')" v-model.lazy="rank">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('firstName')" class="col-sm-4 col-form-label">First name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('firstName')" v-model.lazy="firstName">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('lastName')" class="col-sm-4 col-form-label">Last name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('lastName')" v-model.lazy="lastName">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('country')" class="col-sm-4 col-form-label">Country</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('country')" v-model.lazy="country">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('score')" class="col-sm-4 col-form-label">Score</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('score')" v-model.lazy="score">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('value1')" class="col-sm-4 col-form-label">Value 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('value1')" v-model.lazy="value1">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('value2')" class="col-sm-4 col-form-label">Value 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('value2')" v-model.lazy="value2">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('value3')" class="col-sm-4 col-form-label">Value 3</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('value3')" v-model.lazy="value3">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('value4')" class="col-sm-4 col-form-label">Value 4</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('value4')" v-model.lazy="value4">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('value5')" class="col-sm-4 col-form-label">Value 5</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('value5')" v-model.lazy="value5">
        </div>
      </div>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group form-row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>

      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label">Fields</label>
        <div class="col-sm-8">
          <input type="text" readonly class="form-control-plaintext" :value="datasetColumns">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('patternRank')" class="col-sm-4 col-form-label">Rank</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternRank')" v-model.lazy="patternRank">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('patternFirstName')" class="col-sm-4 col-form-label">First name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternFirstName')" v-model.lazy="patternFirstName">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('patternLastName')" class="col-sm-4 col-form-label">Last name</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternLastName')" v-model.lazy="patternLastName">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternCountry')" class="col-sm-4 col-form-label">Country</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternCountry')" v-model.lazy="patternCountry">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternScore')" class="col-sm-4 col-form-label">Score</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternScore')" v-model.lazy="patternScore">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('patternValue1')" class="col-sm-4 col-form-label">Value 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternValue1')" v-model.lazy="patternValue1">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('patternValue2')" class="col-sm-4 col-form-label">Value 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternValue2')" v-model.lazy="patternValue2">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('patternValue3')" class="col-sm-4 col-form-label">Value 3</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternValue3')" v-model.lazy="patternValue3">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('patternValue4')" class="col-sm-4 col-form-label">Value 4</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternValue4')" v-model.lazy="patternValue4">
        </div>
      </div>

      <div class="form-group form-row">
        <label :for="safeId('patternValue5')" class="col-sm-4 col-form-label">Value 5</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternValue5')" v-model.lazy="patternValue5">
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
  import { templateMixin } from '@/mixins'
  import { mapOverlayData, mapTemplateData } from '../../utils/index'

  export default {
    name: 'fig-score-card',
    mixins: [templateMixin],
    computed: {
      ...mapOverlayData(['rank', 'firstName', 'lastName', 'country', 'score', 'value1', 'value2', 'value3', 'value4', 'value5']),
      ...mapTemplateData(['datasetId', 'recordId']),
      ...mapTemplateData({
        /* eslint-disable no-template-curly-in-string */
        patternRank: {default: '${rank}'},
        patternFirstName: {default: '${firstName}'},
        patternLastName: {default: '${lastName}'},
        patternCountry: {default: '${country}'},
        patternScore: {default: '${score}'},
        patternValue1: {default: ''},
        patternValue2: {default: ''},
        patternValue3: {default: ''},
        patternValue4: {default: ''},
        patternValue5: {default: ''}
        /* eslint-enable no-template-curly-in-string */
      }),
      dataset () {
        if (!this.datasetId) return null
        return this.$store.getters.dataset(this.datasetId)
      },
      datasetColumns () {
        if (!this.dataset) return
        return this.dataset.columns || []
      }
    },
    watch: {
      recordId: function (val) {
        if (!val) return
        let record = this.$store.getters.dataset(this.datasetId).records
          .find(r => r.recordId === val)
        if (!record) return
        record = this.mapRecord(record)
        this.rank = record.rank
        this.firstName = record.firstName
        this.lastName = record.lastName
        this.country = record.country
        this.score = record.score
        this.value1 = record.value1
        this.value2 = record.value2
        this.value3 = record.value3
        this.value4 = record.value4
        this.value5 = record.value5
      }
    },
    methods: {
      nextRecord (prevRecordId, datasetId) {
        const records = this.$store.getters.datasetRecords(datasetId)
        const index = records.findIndex(p => p.recordId === prevRecordId)
        this.recordId = records.length > index + 1 ? records[index + 1].recordId : records[0].recordId
      },
      mapRecord (record) {
        const result = {}
        const recordMap = {
          rank: this.patternRank,
          firstName: this.patternFirstName,
          lastName: this.patternLastName,
          country: this.patternCountry,
          score: this.patternScore,
          value1: this.patternValue1,
          value2: this.patternValue2,
          value3: this.patternValue3,
          value4: this.patternValue4,
          value5: this.patternValue5
        }
        for (let k in recordMap) {
          if (!recordMap.hasOwnProperty(k)) continue
          result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
            return record[p1] || ''
          })
        }
        return result
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/templates/fig-score-card.vue